import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-principal-message',
  templateUrl: './principal-message.component.html',
  styleUrls: ['./principal-message.component.scss']
})
export class PrincipalMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
